import { useTheme } from "@mui/material";
import type { FC } from "react";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { MissingAdvisor } from "web_myplann/Profile/Components/MissingAdvisor";
import { PersonalDataList } from "web_myplann/Profile/Components/PersonalDataList";
import { usePersonalDataFields } from "web_myplann/Profile/Hooks/usePersonalDataFields";
import { MyPlannLoading } from "web_myplann/Shared/Components/MyPlannLoading";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import NavigationHeader from "web_myplann/Shared/Header/NavigationHeader";

const R = Resources.PersonalDataAndAccounts.PersonalData;

export const PersonalDataV2Page: FC = () => {
	const theme = useTheme();
	const { t } = useResource();
	const { clientNotFound, fields, isLoading } = usePersonalDataFields();

	return (
		<MyPlannLayout
			disableContentPadding
			bgColor={theme.palette.grey[50]}
			topBar={
				<NavigationHeader
					title={t(R.title)}
					bgColor={theme.palette.background.appBar}
					defaultRoute={Routing.Profile.ProfileDetail.path()}
					backIconColor={theme.palette.grey[700]}
				/>
			}
		>
			{isLoading ? (
				<MyPlannLoading />
			) : clientNotFound ? (
				<MissingAdvisor />
			) : (
				<PersonalDataList fields={fields} />
			)}
		</MyPlannLayout>
	);
};
